import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/app.vue").then(m => m.default || m)),
  "store-cart": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/store-cart.vue").then(m => m.default || m)),
  store: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/store.vue").then(m => m.default || m)),
  "super-admin": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/super-admin.vue").then(m => m.default || m)),
  "tienda-public": defineAsyncComponent(() => import("/opt/buildhome/repo/layers/tienda/layouts/tienda-public.vue").then(m => m.default || m))
}